var map = {
	"./enclosure.svg": "/7+q",
	"./nav_icon1.svg": "x50Q",
	"./nav_icon2.svg": "eWDP",
	"./nav_icon3.svg": "IUk/",
	"./nav_icon4.svg": "Ou/g",
	"./nav_icon5.svg": "83nr",
	"./nav_icon5_tip.svg": "0OUN",
	"./nav_icon6.svg": "8d1X",
	"./nav_icon7.svg": "CrW6",
	"./source.svg": "hUUe",
	"./time.svg": "RJM1",
	"./u48.svg": "a3pR",
	"./u54.svg": "V8LN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 23